:host {
  display: block;
}

::slotted(*) {
  width: 100%;
}

.ico-modal-x {
  color: var(--clrs-ico-modal-x-text-color);
  background-color: var(--clrs-ico-modal-x-bg-color);
  @apply hover:shadow-md w-10 h-10 p-0 top-3 right-3 md:right-5 absolute rounded-full text-center align-middle cursor-pointer border-0;
}
